module.exports = __webpack_public_path__ + "r-v3/img/ico_modify_black.7151e987.svg";